import 'styles/application.scss';
import React, { PropsWithChildren } from 'react';
import { Toaster } from 'sonner';

type Props = PropsWithChildren;

const BaseLayout = (props: Props) => (
  <>
    <Toaster />
    {props.children}
  </>
);

export default BaseLayout;
